<template>
    <div class="social-media-card">
        <div class="social-content">
            <div class="media" v-show="images.length">
                <img-swiper
                    class="images-swiper"
                    ref="imgSwiper"
                    @change="onPreviewChange"
                    @load="onImageLoad"
                    :style="{ height: imgHeight + 'px' }"
                    :allImagesJson="imagesJson"
                    :alt="content"
                    dir="width"
                >
                    <template #button-prev>
                        <div
                            class="swiper-prev"
                            @click.stop.prevent="changePreview($event, 'prev')"
                            v-show="!isMobileDevice && previewIndex > 0"
                        >
                            <div class="bg"></div>
                            <i class="iconfont icon-chevron_right"></i>
                        </div>
                    </template>
                    <template #button-next>
                        <div
                            @click.stop.prevent="changePreview($event, 'next')"
                            class="swiper-next"
                            v-show="
                                !isMobileDevice &&
                                    previewIndex < images.length - 1
                            "
                        >
                            <div class="bg"></div>
                            <i class="iconfont icon-chevron_right"></i>
                        </div>
                    </template>
                    <template #mask>
                        <div class="dot-mask" v-show="images.length > 1">
                            <div
                                class="dot"
                                v-for="(_, idx) in images"
                                :key="idx"
                                :class="{ active: idx == previewIndex }"
                            ></div>
                        </div>
                    </template>
                </img-swiper>
            </div>
            <div class="text">{{ content }}</div>
            <div class="time-source">
                <p class="time">
                    <only-client>{{ $ft.formatDate(createTime, 'MMM dd, yyyy') }}</only-client>
                </p>
                <a :href="url" target="_blank" rel="noopener noreferrer" :aria-label="sourceClass">
                    <i
                        v-if="socialType != Tiktok_TYPE"
                        class="iconfont source"
                        :class="sourceClass"
                        :style="sourceStyle"
                    ></i>
                    <div v-else class="icon-tiktok-round"></div>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import cardMixin from '../cardMixin';

export default {
    mixins: [cardMixin]
};
</script>
<style lang="scss">
.social-media-card {
    display: block;
    border-radius: 0;
    border: solid 1px var(--g-border-color, #dadada);
    background: var(--g-bg-color, #fff);
    border-radius: 5px;
    overflow: hidden;
    font-family: var(--font-normal);
    display: block;
    .images-swiper {
        position: relative;
        width: 100%;
        .swiper-prev,
        .swiper-next {
            position: absolute;
            width: 26px;
            height: 26px;
            overflow: hidden;
            border-radius: 50%;
            top: 50%;
            transform: translateY(-50%);
            z-index: 1;
            color: #fff;
            cursor: pointer;
            .iconfont {
                font-size: 14px;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(calc(-50% + 2px), -50%);
            }
            .bg {
                background-color: rgba(0, 0, 0, 0.3);
                width: 100%;
                height: 100%;
            }
            &.swiper-button-disabled {
                opacity: 0.5;
            }
            &:hover {
                box-shadow: 0 8px 20px 0 rgba(0, 10, 30, 0.15);
                .bg {
                    background-color: var(--g-primary-color, #333);
                    opacity: 0.4;
                }
            }
        }
        .swiper-prev {
            left: 5px;
            .iconfont {
                transform: translate(calc(-50% - 2px), -50%) rotate(180deg);
            }
        }
        .swiper-next {
            right: 5px;
        }
        .dot-mask {
            display: flex;
            justify-content: center;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 1;
        }
        .dot {
            width: 5px;
            height: 5px;
            border-radius: 50%;
            margin: 5px 3px;
            background-color: rgba(255, 255, 255, 0.4);
            &.active {
                background: #fff;
            }
        }
    }
    @media (min-width: 601px) {
        &:hover {
            box-shadow: 0 8px 20px 0 rgba(0, 10, 30, 0.1);
            border: solid 1px var(--g-primary-color, #333);
        }
    }
    .social-content {
        > .media {
            img {
                width: 100%;
                display: block;
            }
        }
        > .text {
            line-height: 1.33;
            font-size: 12px;
            color: var(--g-text-color, #202437);
            margin: 15px;
            padding: 0;
            overflow-wrap: break-word;
            word-break: break-word;

            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 6;
            line-clamp: 6;
            max-height: 96px;
        }
        > .time-source {
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            color: var(--g-secondary-text-color, #797e8b);
            height: 40px;
            box-sizing: content-box;
            border-top: 1px solid var(--g-border-color, #dadada);
            padding: 0 15px;
            .time {
                font-size: 12px;
                line-height: 15px;
            }
            .source {
                font-size: 20px;
            }
            .icon-tiktok-round {
                background-image: url(https://cdn.chime.me/image/fs/sitebuild/2022828/19/original_04f465ef-ec7a-486f-a76f-6e2d369319c9.png);
                background-size: contain;
                background-repeat: no-repeat;
                width: 28px;
                height: 28px;
                border-radius: 50%;
            }
        }
    }
}
</style>
